// extracted by mini-css-extract-plugin
export default {"buttonMain":"CountriesPageMenuItem_buttonMain__JcZ-E","buttonSelected":"CountriesPageMenuItem_buttonSelected__-wOmG","title":"CountriesPageMenuItem_title__dczrI"};